/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { Category, DataLayerClient, IDataLayerClient } from '@studyportals/datalayer';

declare const ENVIRONMENT_CONFIG: string;

export class DataLayerEventSender {
	private dataLayerClient: IDataLayerClient;
	private environment = ENVIRONMENT_CONFIG;

	constructor() {
		this.dataLayerClient = new DataLayerClient();

		this.bootDataLayer();
		this.sendPageData();
		this.sendStudyData();
		this.sendOrganisationData();
	}

	private bootDataLayer(): void {
		this.dataLayerClient.initialiseDataLayer();
	}

	private sendPageData(): void {
		this.dataLayerClient.sendPageData({
			category: this.getPageCategory(),
			portal: window.PortalType,
			environment: this.environment,
			url: window.location.href,
			host: window.location.host,
			path: window.location.pathname,
			query: window.location.search,
			referrer: document.referrer
		});
	}

	private sendOrganisationData(): void {
		this.dataLayerClient.sendOrganisationData(window.DataLayerOrganisationData);
	}

	private sendStudyData(): void {
		let studyData = window.DataLayerStudyData;
		if (studyData) {
			studyData = {
				...window.DataLayerStudyData,
				isPremium: this.isStudyPremium()
			};
		}

		this.dataLayerClient.sendStudyData(studyData);
	}

	private isStudyPremium(): boolean {
		const trackingData = document.getElementById('TrackingData');
		return trackingData?.dataset.label === 'premium';
	}

	private getPageCategory(): Category | undefined {
		const categoryString = window.location.pathname.split('/')[1] ?? '';
		const subCategoryString = window.location.pathname.split('/')[2] ?? '';

		switch (categoryString) {
			case 'search':
				if (subCategoryString === 'scholarships') {
					return Category.SCHOLARSHIP_SEARCH;
				} else {
					return Category.SEARCH;
				}
			case 'studies':
				return Category.STUDY;
			case 'universities':
				return Category.UNIVERSITY;
			case 'countries':
				if (subCategoryString === 'degrees') {
					return Category.COUNTRY_DEGREE;
				} else {
					return Category.COUNTRY;
				}
			case 'disciplines':
				return Category.DISCIPLINE;
			case 'visa-info':
				return Category.VISA_INFO;
			case 'rankings':
				return Category.RANKING;
			case 'ranking-country':
				return Category.RANKING_COUNTRY;
			case 'rankings-reviews':
				return Category.RANKINGS_REVIEW;
			case 'scholarships':
				return Category.SCHOLARSHIP;
			case 'university-rankings':
				return Category.META_RANKING;
			case 'articles':
				return Category.ARTICLE;
			case 'study-options':
				return Category.STUDY_OPTIONS;
			case 'cities':
				return Category.CITY;
			case 'personality-test':
				return Category.PERSONALITY_TEST;
			case 'country-test':
				return Category.COUNTRY_TEST;
			case 'account':
				return Category.ACCOUNT;
			case 'chat-with-students':
				return Category.UNIBUDDY;

			default:
				if (window.location.pathname === '/') {
					return Category.HOME;
				}
				return undefined;
		}
	}
}

new DataLayerEventSender();
